
var Model = require("./types/Model.js");
var querystring = require("querystring");

var window = require("global");
var location = window.location;

module.exports = Model({
	name: "querystring",
	init: init
});

function init() {
	if(!location)
		return;
	this.push(parse_url());
}

function parse_url() {
	var query = location.search.slice(1);
	return querystring.parse(query);
}
